'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Bell } from 'lucide-react';
import NotificationsWrapper from '@/components/notifications/notifications-wrapper';

export default function NotificationsMobile({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const toggleNotifications = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex flex-col">
      <button
        className="group hover:bg-sidebar-accent hover:text-sidebar-accent-foreground active:bg-sidebar-accent active:text-sidebar-accent-foreground flex h-10 w-full cursor-pointer items-center gap-2 rounded-lg p-2 text-sm transition-colors"
        aria-label={'Notifications'}
        onClick={toggleNotifications}
      >
        <Bell
          size={18}
          className="text-sidebar-foreground group-hover:text-sidebar-accent-foreground"
        />
        <span className="text-sidebar-foreground flex-1 text-left">{'Notifications'}</span>
      </button>

      {isOpen && (
        <div className="bg-grey-25 dark:bg-grey-1000 absolute top-0 w-full">
          <NotificationsWrapper />
        </div>
      )}
    </div>
  );
}
